<template>
  <v-autocomplete
    v-model="user"
    :items="users"
    :disabled="isDisabled"
    :loading="isLoading"
    label="User"
    @input="onInput"
  />
</template>

<script>
export default {
  name: 'UserSelect',
  data: () => ({
    isLoading: false,
    user: null,
    users: []
  }),
  props: {
    value: Number,
    disabled: Boolean
  },
  computed: {
    isDisabled: function () {
      // If we're loading information or the parent has specified that we should
      // be disabled, then we are
      if (this.isLoading || this.disabled) {
        return true
      } else {
        return false
      }
    }
  },
  mounted: function () {
    // Make sure we get our initial value right since our watch method won't
    // trigger unless the value *changes*, which might not always be the case
    this.user = this.value

    var _this = this
    this.isLoading = true
    this.axios.get('/auth/users')
      .then(function (res) {
        for (let i in res.data) {
          let v = res.data[i]

          // XXX: Allow to limit by role, probably through a component prop?

          // Get a name to display if possible
          let name = ''
          if (v.firstName !== null) {
            name = v.firstName
          }
          if (v.lastName !== null) {
            name = name + ' ' + v.lastName
          }
          if (name !== '') {
            name = name + ' - '
          }

          // Get an email address to display
          let email = v.local.email
          if (email === null) {
            if (v.google.email !== null) {
              email = v.google.email
            } else if (v.facebook.email !== null) {
              email = v.facebook.email
            }
          }

          let title = name + email
          _this.users.push({ text: title, value: v.id })
        }
      })
      .catch(this.$root.apiErrorHandler())
      .finally(() => {
        this.isLoading = false
      })
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  },
  methods: {
    // Propagate our selection so it works with a parent v-model
    onInput: function () {
      this.$emit('input', this.user)
    }
  }
}
</script>
